import { CategoryVehicleModel } from './enumerations/category-vehicle-model.model';
import { Pageable } from './pageable.model';

export interface ControlTowerScoreTable {
  content: VehicleWithAllIndicators[];
  pageable: Pageable;
  totalElements: number;
  totalPages: number;
  last: boolean;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  first: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  empty: boolean;
}

export type VehicleWithAllIndicators = {
  vehicleId: number;
  licensePlate: string;
  generalScore: number;
  indicators: KpiIndicator[];
};

export type KpiIndicator = {
  name: string;
  value: number;
  percentChange: number | null;
  group: 'ONE' | 'TWO' | 'THREE' | 'FOUR' | 'FIVE' | 'SIX';
  lowEvents: number | null;
  mediumEvents: number | null;
  highEvents: number | null;
  uniqueEvents: number | null;
};

export type IndicatorDetail = {
  vehicleId: number;
  odometer: number;
  fuelConsumption: number;
  rpmGreen: number;
  rpmYellow: number;
  rpmRed: number;
  acceleratorPositionGreen: number;
  acceleratorPositionYellow: number;
  acceleratorPositionRed: number;
  brakePositionGreen: number;
  brakePositionYellow: number;
  brakePositionRed: number;
  kmPerLiter: number;
};

export const defaultValue: Readonly<ControlTowerScoreTable> = {
  content: [],
  pageable: {
    sort: {
      sorted: false,
      unsorted: false,
      empty: false,
    },
    offset: 0,
    pageNumber: 0,
    pageSize: 0,
    paged: false,
    unpaged: false,
  },
  totalElements: 0,
  totalPages: 0,
  last: false,
  sort: {
    sorted: false,
    unsorted: false,
    empty: false,
  },
  first: false,
  number: 0,
  numberOfElements: 0,
  size: 0,
  empty: false,
};
